export const openingRoles = [
  {
    id: 0,
    generalRole: true,
    title: "Open Role",
    location: "Remote",
  },
  {
    id: 1,
    title: "Data Scientist",
    location: "Remote",
    aboutRole:
      "Join our dynamic team as a Data Scientist, where you’ll work hands-on with customers across the full data science lifecycle—from prototyping to deployment. You’ll build and implement predictive models and, if possible, contribute to generative AI initiatives that drive real business outcomes. This is a remote role, but we prefer candidates based in or near Bangalore for occasional team collaboration.",
    responsibilities: [
      "Collaborate directly with clients to understand business needs and translate them into data-driven solutions.",
      "Own end-to-end model development: data exploration, prototyping, validation, deployment, and monitoring.",
      "Deliver both predictive analytics and, where possible, generative AI solutions to solve complex business problems.",
      "Present findings, actionable insights, and recommendations to both technical and non-technical stakeholders.",
      "Stay current with the latest advancements in AI and data science to continuously enhance our offerings.",
    ],
    lookingFor: [
      "3–5 years of hands-on experience in data science, including customer-facing roles.",
      "Proven track record in building and deploying predictive models; experience with generative AI is a strong plus.",
      "Proficiency in Python and SQL; experience with cloud platforms is desirable.",
      "Excellent communication skills and ability to explain complex concepts clearly.",
      "Bachelor’s or Master’s degree in Data Science, Computer Science, Statistics, or a related field.",
      "Based in Bangalore or willing to work Indian business hours remotely",
    ],
  },
  {
    id: 3,
    title: "AI Strategy Consultant",
    location: "Remote",
    aboutRole:
      "We’re seeking an AI Strategy Consultant to join our growing team! In this fully client-facing role, you’ll partner with organizations to define their AI and data strategies, identify high-impact use cases, and guide clients on their journey to AI-driven transformation. If you have a strategic mindset, strong problem-solving skills, and a passion for working directly with clients, we want to hear from you.",
    responsibilities: [
      "Engage with clients to understand business objectives and develop tailored AI and data strategies.",
      "Lead use case discovery workshops, identifying opportunities where AI can deliver measurable business value.",
      "Advise clients on best practices for data management, AI adoption, and change management.",
      "Translate complex technical concepts into clear, actionable recommendations for executive and operational stakeholders.",
      "Stay up-to-date with the latest trends in AI, data analytics, and industry best practices.",
      "Collaborate with internal technical teams to ensure seamless delivery of AI solutions.",
    ],
    lookingFor: [
      "3–5 years of experience in AI strategy, management consulting, or a related field.",
      "Demonstrated expertise in AI and data strategy, use case identification, and client engagement.",
      "Exceptional communication and presentation skills, with the ability to influence senior stakeholders.",
      "Strong analytical and problem-solving abilities, with a knack for strategic thinking.",
      "Bachelor’s or Master’s degree in Business, Computer Science, Data Science, or a related discipline.",
      "Willingness to travel or work flexible hours to accommodate client needs.",
    ],
  },
];
